module.exports = __webpack_public_path__ + "static/media/aceton_2.7bb6054b.png";